const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { internalSwimlaneExportSearchSchema } from '@/features/views/components/export/ExportSwimlanePage';

/**
 * Export route for roadmap PNG generation with token authentication
 *
 * This route is accessed exclusively by the backend worker using a temporary JWT token.
 * It provides the same rendering as published roadmaps but without requiring publication.
 *
 * Authentication: JWT token passed via ?token= query parameter (validated by backend API)
 * URL Pattern: /export/v1/loop-visualization/view/:viewId/visualization/:visualizationId/swimlane/png?token={jwt}&...
 *
 * Query Parameters:
 * - token (required): JWT export token
 * - title (optional): '0' to hide title
 * - branding (optional): '0' to hide branding
 * - date (optional): '0' to hide publish date
 * - legend (optional): '0' to hide legend
 * - vision (optional): Custom vision statement text
 * - transparent (optional): '1' to enable transparent background
 *
 * Note: Token validation happens on the backend when fetching data.
 * Frontend does not have access to EXPORT_TOKEN_SECRET.
 * This route is always in export mode - the 'export' query parameter is not required.
 */
export const Route = createFileRoute('/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png')({
  validateSearch: zodValidator(internalSwimlaneExportSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});